import { createRoute } from "@tanstack/react-router";
import { RoleGuard } from "@/components/auth/RoleGuard";
import { PromptsAdmin } from "@/pages/admin/PromptsAdmin";
import { Route as RootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: "/admin/prompts/$meetingTypeId",
  component: PromptsAdminRoute,
});

function PromptsAdminRoute() {
  const { meetingTypeId } = Route.useParams();
  return (
    <RoleGuard action="prompt_edit">
      <PromptsAdmin meetingTypeId={meetingTypeId} />
    </RoleGuard>
  );
}
